module.exports = __webpack_public_path__ + "img/Avatar.2f69df4d.svg";